(() => {
  "use strict";

  const DRUGS = [
    { cat:"Cardiac arrest / CPR (RECOVER)", items:[
      { name:"Adrenaline (epinephrine) — low dose", note:"First-line, every other CPR cycle", route:"IV / IO", doseUnit:"mg/kg", dog:0.01, cat:0.01, conc:1, concLabel:"mg/mL", concRef:"1:1000" },
      { name:"Adrenaline (epinephrine) — high dose", note:"Prolonged CPR only", route:"IV / IO", doseUnit:"mg/kg", dog:0.1, cat:0.1, conc:1, concLabel:"mg/mL", concRef:"1:1000" },
      { name:"Atropine", note:"Asystole / bradycardic arrest / vagal", route:"IV / IO", doseUnit:"mg/kg", dog:0.04, cat:0.04, conc:0.6, concLabel:"mg/mL" },
      { name:"Glycopyrrolate", note:"Bradycardia — longer-acting anticholinergic alternative to atropine", route:"IV / IM", doseUnit:"mg/kg", dog:0.01, cat:0.01, conc:0.2, concLabel:"mg/mL" },
      { name:"Vasopressin", note:"Alternative to adrenaline", route:"IV / IO", doseUnit:"U/kg", dog:0.8, cat:0.8, conc:20, concLabel:"U/mL" },
      { name:"Amiodarone", note:"Refractory VF / pulseless VT (dog)", route:"IV / IO", doseUnit:"mg/kg", dog:5, cat:5, conc:50, concLabel:"mg/mL" },
      { name:"Lidocaine (2%)", note:"Ventricular arrhythmia. CAUTION in cats", route:"IV slow", doseUnit:"mg/kg", dog:2, cat:0.25, conc:20, concLabel:"mg/mL", catFlag:"Cat: give slowly, low dose — cats are sensitive" },
      { name:"Naloxone", note:"Reverse opioids", route:"IV / IM", doseUnit:"mg/kg", dog:0.04, cat:0.04, conc:0.4, concLabel:"mg/mL" },
      { name:"Flumazenil", note:"Reverse benzodiazepines", route:"IV", doseUnit:"mg/kg", dog:0.01, cat:0.01, conc:0.1, concLabel:"mg/mL" }
    ]},
    { cat:"Seizures / status epilepticus", items:[
      { name:"Diazepam", note:"First-line seizure control", route:"IV", doseUnit:"mg/kg", dog:0.5, cat:0.5, conc:5, concLabel:"mg/mL" },
      { name:"Midazolam", note:"IV or IM if no access", route:"IV / IM", doseUnit:"mg/kg", dog:0.2, cat:0.2, conc:5, concLabel:"mg/mL" },
      { name:"Levetiracetam", note:"Add-on / loading", route:"IV", doseUnit:"mg/kg", dog:60, cat:60, conc:100, concLabel:"mg/mL" },
      { name:"Phenobarbital", note:"Loading, in increments to effect", route:"IV", doseUnit:"mg/kg", dog:4, cat:4, conc:200, concLabel:"mg/mL" }
    ]},
    { cat:"Anaphylaxis / allergic", items:[
      { name:"Adrenaline (epinephrine)", note:"Anaphylaxis first-line", route:"IM / IV", doseUnit:"mg/kg", dog:0.01, cat:0.01, conc:1, concLabel:"mg/mL", concRef:"1:1000" },
      { name:"Diphenhydramine", note:"Antihistamine, give IM", route:"IM", doseUnit:"mg/kg", dog:2, cat:2, conc:50, concLabel:"mg/mL" },
      { name:"Dexamethasone sodium phosphate", note:"Anti-inflammatory", route:"IV", doseUnit:"mg/kg", dog:0.2, cat:0.2, conc:4, concLabel:"mg/mL" }
    ]},
    { cat:"Metabolic / electrolyte", items:[
      { name:"Dextrose 50%", note:"Hypoglycaemia — dilute 1:2–1:4 before IV", route:"IV slow", doseUnit:"mL/kg", dog:1, cat:1, conc:500, concLabel:"mg/mL", concRef:"50%" },
      { name:"Calcium gluconate 10%", note:"Hyperkalaemia / hypocalcaemia. Slow, monitor ECG", route:"IV slow", doseUnit:"mL/kg", dog:1, cat:1, conc:100, concLabel:"mg/mL", concRef:"10%" },
      { name:"Sodium bicarbonate 8.4%", note:"Severe metabolic acidosis", route:"IV slow", doseUnit:"mEq/kg", dog:1, cat:1, conc:1, concLabel:"mEq/mL" },
      { name:"Furosemide", note:"Fluid overload / oliguria / CHF", route:"IV / IM", doseUnit:"mg/kg", dog:2, cat:2, conc:50, concLabel:"mg/mL" }
    ]},
    { cat:"Cerebral / raised ICP", items:[
      { name:"Mannitol 20%", note:"Cerebral oedema — over 15–20 min, use filter", route:"IV", doseUnit:"g/kg", dog:1, cat:1, conc:0.2, concLabel:"g/mL", concRef:"20%" },
      { name:"Hypertonic saline 7.2%", note:"Raised ICP / hypovolaemia", route:"IV slow", doseUnit:"mL/kg", dog:4, cat:3, conc:72, concLabel:"mg/mL", concRef:"7.2%" }
    ]},
    { cat:"Toxin / emesis", items:[
      { name:"Apomorphine", note:"Induce emesis — DOGS ONLY", route:"IV / SC", doseUnit:"mg/kg", dog:0.03, cat:null, conc:3, concLabel:"mg/mL", catFlag:"Not for cats — use dexmedetomidine for feline emesis" },
      { name:"Intralipid 20%", note:"Lipid rescue for fat-soluble toxins", route:"IV", doseUnit:"mL/kg", dog:1.5, cat:1.5, conc:200, concLabel:"mg/mL", concRef:"20%" },
      { name:"Atipamezole", note:"Reverse alpha-2 agonists (dexmed/xylazine)", route:"IM", doseUnit:"mg/kg", dog:0.1, cat:0.1, conc:5, concLabel:"mg/mL" }
    ]},
    { cat:"Thromboembolism / coagulation", items:[
      { name:"Heparin (unfractionated)", note:"FATE (cats) / DIC / thromboprophylaxis — follow your protocol", route:"IV / SC", doseUnit:"U/kg", dog:100, cat:100, conc:1000, concLabel:"U/mL", concRef:"varies 1000–25000" }
    ]},
    { cat:"Intratracheal — no IV / IO access", desc:"Last resort when you genuinely cannot get vascular access. Intratracheal doses are higher than IV (commonly 2–10×), diluted in saline or sterile water and delivered through a long catheter passed beyond the ET-tube tip, followed by a few positive-pressure breaths. Doses below are prefilled at roughly 2× IV — adjust to your protocol.", items:[
      { name:"Adrenaline (epinephrine) — IT", note:"Dilute in saline, deliver past ET tip", route:"IT", doseUnit:"mg/kg", dog:0.02, cat:0.02, conc:1, concLabel:"mg/mL", concRef:"1:1000" },
      { name:"Atropine — IT", note:"Dilute in saline, deliver past ET tip", route:"IT", doseUnit:"mg/kg", dog:0.08, cat:0.08, conc:0.6, concLabel:"mg/mL" },
      { name:"Vasopressin — IT", note:"Dilute in saline, deliver past ET tip", route:"IT", doseUnit:"U/kg", dog:1.6, cat:1.6, conc:20, concLabel:"U/mL" },
      { name:"Naloxone — IT", note:"Reverse opioids when no IV access", route:"IT", doseUnit:"mg/kg", dog:0.08, cat:0.08, conc:0.4, concLabel:"mg/mL" },
      { name:"Lidocaine (2%) — IT", note:"Ventricular arrhythmia. CAUTION in cats", route:"IT", doseUnit:"mg/kg", dog:4, cat:0.5, conc:20, concLabel:"mg/mL", catFlag:"Cat: very low dose — cats are highly sensitive to lidocaine" }
    ]}
  ];

  class EmergencyDrugCalculator extends HTMLElement {
    constructor() {
      super();

      this.species = "dog";
      this.unit = "kg";

      this.handleSpeciesClick = this.handleSpeciesClick.bind(this);
      this.handleUnitClick = this.handleUnitClick.bind(this);
      this.handleWeightInput = this.handleWeightInput.bind(this);
      this.handleReset = this.handleReset.bind(this);
      this.handlePrint = this.handlePrint.bind(this);
      this.handleTablesInput = this.handleTablesInput.bind(this);
    }

    connectedCallback() {
      if (this.initialized) return;

      this.speciesSegment = this.querySelector("[data-species-segment]");
      this.unitSegment = this.querySelector("[data-unit-segment]");
      this.weightInput = this.querySelector("[data-weight]");
      this.kgNote = this.querySelector("[data-kg-note]");
      this.resetButton = this.querySelector("[data-reset]");
      this.printButton = this.querySelector("[data-print]");
      this.tablesHost = this.querySelector("[data-tables]");

      if (!this.tablesHost) return;

      this.speciesSegment?.addEventListener("click", this.handleSpeciesClick);
      this.unitSegment?.addEventListener("click", this.handleUnitClick);
      this.weightInput?.addEventListener("input", this.handleWeightInput);
      this.resetButton?.addEventListener("click", this.handleReset);
      this.printButton?.addEventListener("click", this.handlePrint);
      this.tablesHost.addEventListener("input", this.handleTablesInput);

      this.initialized = true;
      this.build();
    }

    disconnectedCallback() {
      this.speciesSegment?.removeEventListener("click", this.handleSpeciesClick);
      this.unitSegment?.removeEventListener("click", this.handleUnitClick);
      this.weightInput?.removeEventListener("input", this.handleWeightInput);
      this.resetButton?.removeEventListener("click", this.handleReset);
      this.printButton?.removeEventListener("click", this.handlePrint);
      this.tablesHost?.removeEventListener("input", this.handleTablesInput);

      this.initialized = false;
    }

    key(categoryIndex, drugIndex) {
      return `${categoryIndex}-${drugIndex}`;
    }

    kgWeight() {
      const raw = Number.parseFloat(this.weightInput?.value || "");

      if (Number.isNaN(raw) || raw <= 0) return null;

      return this.unit === "lb" ? raw / 2.20462 : raw;
    }

    formatValue(value) {
      if (value === null || !Number.isFinite(value)) return "—";
      if (value === 0) return "0";

      const absolute = Math.abs(value);

      if (absolute >= 100) return value.toFixed(0);
      if (absolute >= 10) return value.toFixed(1);
      if (absolute >= 1) return value.toFixed(2);
      if (absolute >= 0.1) return value.toFixed(2);

      return value.toPrecision(2);
    }

    build() {
      this.tablesHost.innerHTML = "";

      DRUGS.forEach((group, categoryIndex) => {
        const heading = document.createElement("div");
        heading.className = "edc-category-heading";
        heading.textContent = group.cat;
        this.tablesHost.appendChild(heading);

        if (group.desc) {
          const description = document.createElement("p");
          description.className = "edc-category-description";
          description.textContent = group.desc;
          this.tablesHost.appendChild(description);
        }

        const tableWrap = document.createElement("div");
        tableWrap.className = "edc-table-wrap";

        const table = document.createElement("table");
        table.innerHTML = `
          <thead>
            <tr>
              <th style="width: 32%;">Drug</th>
              <th>Route</th>
              <th>Dose</th>
              <th>Conc.</th>
              <th>Total dose</th>
              <th style="width: 15%;">Volume</th>
            </tr>
          </thead>
          <tbody></tbody>
        `;

        const tableBody = table.querySelector("tbody");

        group.items.forEach((drug, drugIndex) => {
          const rowKey = this.key(categoryIndex, drugIndex);
          const numeratorUnit = drug.doseUnit.split("/")[0];
          const isMillilitresPerKilogram = numeratorUnit === "mL";
          const row = document.createElement("tr");
          row.dataset.key = rowKey;

          const flag = this.species === "cat" && drug.catFlag
            ? `<span class="edc-flag">⚠ ${drug.catFlag}</span>`
            : "";

          row.innerHTML = `
            <td class="edc-drug">
              ${drug.name}
              <small>${drug.note}${flag ? `<br>${flag}` : ""}</small>
            </td>
            <td class="edc-route">${drug.route}</td>
            <td class="edc-dose-cell">
              <input class="edc-dose" type="number" min="0" step="any" data-key="${rowKey}">
              <span class="edc-unit">${drug.doseUnit}</span>
            </td>
            <td class="edc-concentration-cell">
              <input
                class="edc-concentration"
                type="number"
                min="0"
                step="any"
                data-key="${rowKey}"
                value="${drug.conc}"
                ${isMillilitresPerKilogram ? 'disabled title="Reference only — this drug is dosed directly in mL/kg"' : ""}
              >
              <span class="edc-concentration-unit">
                ${drug.concLabel}${drug.concRef ? ` (${drug.concRef})` : ""}
              </span>
            </td>
            <td class="edc-total" data-total></td>
            <td class="edc-volume" data-volume></td>
          `;

          tableBody.appendChild(row);
        });

        tableWrap.appendChild(table);
        this.tablesHost.appendChild(tableWrap);
      });

      this.loadDefaults();
      this.recalculate();
    }

    loadDefaults() {
      this.querySelectorAll(".edc-dose").forEach((input) => {
        const [categoryIndex, drugIndex] = input.dataset.key.split("-").map(Number);
        const drug = DRUGS[categoryIndex].items[drugIndex];
        const defaultDose = drug[this.species];

        input.value = defaultDose === null || defaultDose === undefined ? "" : defaultDose;
        input.disabled = defaultDose === null || defaultDose === undefined;
        input.classList.remove("is-edited");
      });

      this.querySelectorAll(".edc-concentration").forEach((input) => {
        const [categoryIndex, drugIndex] = input.dataset.key.split("-").map(Number);
        const drug = DRUGS[categoryIndex].items[drugIndex];

        input.value = drug.conc;
        input.classList.remove("is-edited");
      });
    }

    recalculate() {
      const weightInKilograms = this.kgWeight();

      if (this.kgNote) {
        this.kgNote.textContent = weightInKilograms
          ? `${weightInKilograms.toFixed(1)} kg`
          : "—";
      }

      this.querySelectorAll("tr[data-key]").forEach((row) => {
        const [categoryIndex, drugIndex] = row.dataset.key.split("-").map(Number);
        const drug = DRUGS[categoryIndex].items[drugIndex];
        const numeratorUnit = drug.doseUnit.split("/")[0];
        const doseInput = row.querySelector(".edc-dose");
        const concentrationInput = row.querySelector(".edc-concentration");
        const totalCell = row.querySelector("[data-total]");
        const volumeCell = row.querySelector("[data-volume]");

        const dose = Number.parseFloat(doseInput.value);
        const concentration = Number.parseFloat(concentrationInput.value);

        if (doseInput.disabled || Number.isNaN(dose) || dose < 0) {
          totalCell.textContent = "—";
          volumeCell.textContent = this.species === "cat" && drug.cat === null ? "Dog only" : "—";
          volumeCell.className = "edc-volume is-na";
          return;
        }

        if (!weightInKilograms) {
          totalCell.textContent = "—";
          volumeCell.textContent = "—";
          volumeCell.className = "edc-volume is-na";
          return;
        }

        const totalDose = dose * weightInKilograms;
        const volume = numeratorUnit === "mL"
          ? totalDose
          : Number.isNaN(concentration) || concentration <= 0
            ? null
            : totalDose / concentration;

        totalCell.textContent = `${this.formatValue(totalDose)} ${numeratorUnit}`;

        if (volume === null) {
          volumeCell.textContent = "—";
          volumeCell.className = "edc-volume is-na";
        } else {
          volumeCell.innerHTML = `${this.formatValue(volume)}<span class="edc-ml"> mL</span>`;
          volumeCell.className = "edc-volume";
        }
      });
    }

    handleSpeciesClick(event) {
      const button = event.target.closest("button[data-species]");

      if (!button || !this.speciesSegment?.contains(button)) return;
      if (button.dataset.species === this.species) return;

      this.species = button.dataset.species;

      this.speciesSegment.querySelectorAll("button[data-species]").forEach((item) => {
        item.classList.toggle("is-active", item === button);
      });

      this.build();
    }

    handleUnitClick(event) {
      const button = event.target.closest("button[data-unit]");

      if (!button || !this.unitSegment?.contains(button)) return;

      const nextUnit = button.dataset.unit;

      if (nextUnit === this.unit) return;

      const currentValue = Number.parseFloat(this.weightInput?.value || "");

      if (Number.isFinite(currentValue) && currentValue > 0) {
        const convertedValue = nextUnit === "lb"
          ? currentValue * 2.20462
          : currentValue / 2.20462;

        this.weightInput.value = convertedValue.toFixed(1);
      }

      this.unit = nextUnit;

      this.unitSegment.querySelectorAll("button[data-unit]").forEach((item) => {
        item.classList.toggle("is-active", item === button);
      });

      this.recalculate();
    }

    handleWeightInput() {
      this.recalculate();
    }

    handleReset() {
      this.loadDefaults();
      this.recalculate();
    }

    handlePrint() {
      window.print();
    }

    handleTablesInput(event) {
      const isDose = event.target.classList.contains("edc-dose");
      const isConcentration = event.target.classList.contains("edc-concentration");

      if (isDose || isConcentration) {
        event.target.classList.add("is-edited");
      }

      this.recalculate();
    }
  }

  if (!customElements.get("s-emergency-drug-calculator")) {
    customElements.define("s-emergency-drug-calculator", EmergencyDrugCalculator);
  }
})();
